import { Button, Card, CardBody, CardHeader } from '@material-tailwind/react'
import { useTranslation } from 'react-i18next'

const CardSkeleton = () => {
    const { i18n } = useTranslation();

    return (
        <section className="mx-auto sm:max-w-5xl lg:max-w-7xl my-10 overflow-hidden py-10" id="courses">
            <div className="relative grid gap-5 sm:grid-cols-1 lg:grid-cols-4">
                <Card className="max-w-sm m-auto mt-8 bg-white rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 transition duration-300 ease-in-out transform hover:scale-100 hover:-translate-y-1 hover:shadow-lg border-2 border-gray-100" dir={i18n.language === "en" ? "ltr" : "rtl"}>
                    <CardHeader className="relative h-auto">
                        <div className="flex items-center justify-center w-full h-40 bg-gray-300 rounded dark:bg-gray-700">
                            <svg className="w-64 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                                <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                                <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                            </svg>
                        </div>
                        <Button
                            variant="filled"
                            color="white"
                            size="sm"
                            className={`absolute text-xs rounded-md p-1 ltr:left-1 rtl:right-1 top-1.5 animate-pulse w-20 h-3`}
                        >
                        </Button>
                    </CardHeader>
                    <CardBody className="">
                        <div className='flex flex-col justify-start items-start gap-2 pb-2 mt-2 text-gray-500'>
                            <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-52"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5 w-16"></div>
                        </div>

                        <div className='flex justify-between items-center gap-2 text-gray-500 mt-3'>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                        </div>

                    </CardBody>
                </Card>
                <Card className="max-w-sm m-auto mt-8 bg-white rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 transition duration-300 ease-in-out transform hover:scale-100 hover:-translate-y-1 hover:shadow-lg border-2 border-gray-100" dir={i18n.language === "en" ? "ltr" : "rtl"}>
                    <CardHeader className="relative h-auto">
                        <div className="flex items-center justify-center w-full h-40 bg-gray-300 rounded dark:bg-gray-700">
                            <svg className="w-64 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                                <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                                <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                            </svg>
                        </div>
                        <Button
                            variant="filled"
                            color="white"
                            size="sm"
                            className={`absolute text-xs rounded-md p-1 ltr:left-1 rtl:right-1 top-1.5 animate-pulse w-20 h-3`}
                        >
                        </Button>
                    </CardHeader>
                    <CardBody className="">
                        <div className='flex flex-col justify-start items-start gap-2 pb-2 mt-2 text-gray-500'>
                            <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-52"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5 w-16"></div>
                        </div>

                        <div className='flex justify-between items-center gap-2 text-gray-500 mt-3'>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                        </div>

                    </CardBody>
                </Card>
                <Card className="max-w-sm m-auto mt-8 bg-white rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 transition duration-300 ease-in-out transform hover:scale-100 hover:-translate-y-1 hover:shadow-lg border-2 border-gray-100" dir={i18n.language === "en" ? "ltr" : "rtl"}>
                    <CardHeader className="relative h-auto">
                        <div className="flex items-center justify-center w-full h-40 bg-gray-300 rounded dark:bg-gray-700">
                            <svg className="w-64 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                                <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                                <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                            </svg>
                        </div>
                        <Button
                            variant="filled"
                            color="white"
                            size="sm"
                            className={`absolute text-xs rounded-md p-1 ltr:left-1 rtl:right-1 top-1.5 animate-pulse w-20 h-3`}
                        >
                        </Button>
                    </CardHeader>
                    <CardBody className="">
                        <div className='flex flex-col justify-start items-start gap-2 pb-2 mt-2 text-gray-500'>
                            <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-52"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5 w-16"></div>
                        </div>

                        <div className='flex justify-between items-center gap-2 text-gray-500 mt-3'>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                        </div>

                    </CardBody>
                </Card>
                <Card className="max-w-sm m-auto mt-8 bg-white rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 transition duration-300 ease-in-out transform hover:scale-100 hover:-translate-y-1 hover:shadow-lg border-2 border-gray-100" dir={i18n.language === "en" ? "ltr" : "rtl"}>
                    <CardHeader className="relative h-auto">
                        <div className="flex items-center justify-center w-full h-40 bg-gray-300 rounded dark:bg-gray-700">
                            <svg className="w-64 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 20">
                                <path d="M14.066 0H7v5a2 2 0 0 1-2 2H0v11a1.97 1.97 0 0 0 1.934 2h12.132A1.97 1.97 0 0 0 16 18V2a1.97 1.97 0 0 0-1.934-2ZM10.5 6a1.5 1.5 0 1 1 0 2.999A1.5 1.5 0 0 1 10.5 6Zm2.221 10.515a1 1 0 0 1-.858.485h-8a1 1 0 0 1-.9-1.43L5.6 10.039a.978.978 0 0 1 .936-.57 1 1 0 0 1 .9.632l1.181 2.981.541-1a.945.945 0 0 1 .883-.522 1 1 0 0 1 .879.529l1.832 3.438a1 1 0 0 1-.031.988Z" />
                                <path d="M5 5V.13a2.96 2.96 0 0 0-1.293.749L.879 3.707A2.98 2.98 0 0 0 .13 5H5Z" />
                            </svg>
                        </div>
                        <Button
                            variant="filled"
                            color="white"
                            size="sm"
                            className={`absolute text-xs rounded-md p-1 ltr:left-1 rtl:right-1 top-1.5 animate-pulse w-20 h-3`}
                        >
                        </Button>
                    </CardHeader>
                    <CardBody className="">
                        <div className='flex flex-col justify-start items-start gap-2 pb-2 mt-2 text-gray-500'>
                            <div className="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-52"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 mb-2.5 w-16"></div>
                        </div>

                        <div className='flex justify-between items-center gap-2 text-gray-500 mt-3'>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                            <div className="h-2 bg-gray-200 rounded-full dark:bg-gray-700 w-10"></div>
                        </div>

                    </CardBody>
                </Card>
            </div>
        </section>
    )
}

export default CardSkeleton